import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken } from "../lib/api";

const AuthContext = createContext(null);
const hasStoredToken = () => !!(localStorage.getItem("gbc_token") || sessionStorage.getItem("gbc_token"));
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=auth

  const refresh = useCallback(async (attempt = 0) => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      return data.user;
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) { setToken(null); setUser(false); return false; }
      // Transient/network/5xx error. If a token exists (e.g. returning from the
      // Stripe portal via a full page load), retry briefly instead of logging out.
      if (hasStoredToken() && attempt < 2) { await sleep(800); return refresh(attempt + 1); }
      setUser((prev) => (prev && typeof prev === "object" ? prev : false));
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, remember = true) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token, remember);
    setUser(data.user);
    return data.user;
  };
  const register = async (email, password, name, remember = true) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setToken(data.token, remember);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
